// extracted by mini-css-extract-plugin
export default {"containerGlobal":"EditeMaster_containerGlobal__elxUx","wrap":"EditeMaster_wrap__UM6yv"};